<template>
  <div>
    <naj-modal
      ref="complete-current-user-info-modal"
      :title="local.lawsuitRequest.currentUserAsCaseParty.modalTitle"
      :width="1700"
      :footer="true"
      @onClose="closeModal"
    >
      <v-form
        v-if="addCurrentUserAsProsecuter"
        ref="complete-current-user-info-form"
        class="complete-current-user-info-form"
      >
        <complete-current-user-info-form
          :case-party="caseParty"
          :attorney-details="attorneyDetails"
        ></complete-current-user-info-form>
      </v-form>
      <v-form
        v-if="addCurrentUserAsAgentOrLawyer && this.attorneyDetails"
        ref="complete-agent-info-form"
        class="complete-agent-info-form"
      >
        <complete-agent-info-form
          ref="complete-agent-info-form-component"
          :attorney-code="attorneyCode"
          :agent.sync="agent"
          :clients.sync="clients"
          :is-lawyer="addCurrentUserAsLawyer"
          :forms-validations="formsValidations"
          :attorney-details="attorneyDetails"
          @onError="onAgentPopupError"
        ></complete-agent-info-form>
      </v-form>
      <template slot="actions">
        <naj-button
          :disabled="submitLoading"
          :loading="submitLoading"
          @click="submit"
        >
          {{ local.common.add }}
        </naj-button>
      </template>
    </naj-modal>

    <naj-modal
      ref="actions-modal"
      class="actions-modal"
      :title="local.lawsuitRequest.currentUserAsCaseParty.requiredAction"
      :width="boxWidth"
      :footer="true"
      :no-h-gutters="true"
      :loading="loading"
      @onClose="onActionsModalClose"
    >
      <v-row>
        <v-col cols="12">
          <p class="modal-header-text">
            {{ this.local.lawsuitRequest.currentUserAsCaseParty.actionType }}
          </p>
          <p class="modal-header-text">
            {{ this.local.lawsuitRequest.currentUserAsCaseParty.chooseActionType }}
          </p>
        </v-col>
      </v-row>
      <v-form
        ref="actions-form"
        class="actions-form"
        @submit.prevent="selectedActionSubmitted"
      >
        <v-row style="overflow: hidden;">
          <v-col
            v-for="radio in actions"
            :key="radio.id"
            :cols="(12/actions.length)"
            class="d-flex col"
            @click="setSelectedAction(radio.id)"
            @mouseover="radio.isHovering = true"
            @mouseleave="radio.isHovering = false"
          >
            <v-card
              :class="[ { 'bordered': radio.id == selectedAction || radio.isHovering, 'elevation-12': radio.id == selectedAction || radio.isHovering }]"
              :disabled="loading"
            >
              <v-card-title></v-card-title>
              <p class="card-headline text-center">
                {{ radio.name }}
              </p>

              <v-icon
                v-if="radio.id == selectedAction || radio.isHovering"
                class="icon-online"
              >
                {{ radio.icon }}
              </v-icon>
              <v-icon
                v-else
                class="icon-offline"
              >
                {{ radio.icon }}
              </v-icon>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-card-text class="description">
                      {{ radio.description1 }} <span class="highlighted">{{ radio.description2 }}</span> {{ radio.description3 }}
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    v-for="(text, index) in radio.textInfo"
                    :key="index"
                    cols="6"
                  >
                    <span class="description">-{{ text }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span class="description">{{ radio.footerText }}</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            v-if="addCurrentUserAsAgentOrLawyer"
            cols="12"
            lg="4"
          >
            <naj-input
              :type-id="formFieldType.number"
              :label="local.attorney.number"
              :value.sync="attorneyCode"
              validates="required"
              :disabled="loading"
            ></naj-input>
          </v-col>

          <v-col
            v-if="isRelative && selectedAction === 2"
            cols="12"
            lg="4"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="local.attorney.relativeDescription"
              :value.sync="relativeDescription"
              validates="required"
              :disabled="loading"
            ></naj-input>
          </v-col>

          <v-col
            v-if="addCurrentUserAsAgent"
            cols="12"
            lg="4"
          >
            <naj-input
              :type-id="formFieldType.checkbox"
              :label="local.attorney.isRelative"
              :value.sync="isRelative"
              :disabled="loading"
            ></naj-input>
          </v-col>
        </v-row>
      </v-form>
      <template slot="actions">
        <naj-button
          :disabled="selectedAction == null || submitLoading || loading"
          :loading="submitLoading"
          @click="selectedActionSubmitted"
        >
          {{ local.common.next }}
        </naj-button>
      </template>
    </naj-modal>
  </div>
</template>

<script>
import CompleteCurrentUserInfoForm from './complete-current-user-info-form';
import CompleteAgentInfoForm from './complete-agent-info-form';
import { partyTypeEnum, casePartyRoleEnum, countriesEnum, socialIdentityTypeEnum } from '@/helpers/enum';
import { uuidGenerator } from '@/helpers/utils';
import { initialData } from '../../../store/state';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');
const { mapActions: mapLUTActions, mapGetters: mapLUTGetters } = createNamespacedHelpers('LookupsModule');
import { userType } from '@/helpers/enum';
export default {
  components: {
    CompleteCurrentUserInfoForm,
    CompleteAgentInfoForm,
  },
  props: {
    addCurrentUserAsCaseParty: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      formsValidations: {},
      selectedAction: null,
      attorneyCode: null,
      isRelative: null,
      relativeDescription: null,
      userType,
      actions: [
        {
          id: 1,
          name: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsProsecuter,
          description1: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsProsecuterDescription1,
          description2: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsProsecuterDescription2,
          description3: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsProsecuterDescription3,
          textInfo: ['المدينة', 'رقم الجوال', 'الحي', 'البريد الإلكتروني'],
          footerText: 'و يمكنك إدخال بيانات باقي الأطراف كاملة مع منح صلاحية للمستفيد بإدخال بيانات الممثل',
          imgLink: './img/addCurrentUserAsProsecuter.png',
          icon: 'mdi-account-convert',
          isHovering: false,
        },
        {
          id: 2,
          name: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsAgent,
          description1: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsAgentDescription1,
          description2: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsAgentDescription2,
          description3: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsAgentDescription3,
          textInfo: ['المدينة', 'رقم الجوال', 'الحي', 'البريد الإلكتروني'],
          footerText: '',
          imgLink: './img/addCurrentUserAsAgent.png',
          icon: 'mdi-account-multiple',
          isHovering: false,
        },
        {
          id: 3,
          name: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsLawyer,
          description1: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsLawyerDescription1,
          description2: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsLawyerDescription2,
          description3: this.local.lawsuitRequest.currentUserAsCaseParty.addCurrentUserAsLawyerDescription3,
          textInfo: ['المدينة', 'رقم الجوال', 'الحي', 'البريد الإلكتروني'],
          footerText: '',
          imgLink: './img/addCurrentUserAsLawyer.png',
          icon: 'mdi-account-switch',
          isHovering: false,
        },
        {
          id: 0,
          name: this.local.lawsuitRequest.currentUserAsCaseParty.addNewCaseParty,
          description1: this.local.lawsuitRequest.currentUserAsCaseParty.addNewCasePartyDescription1,
          description2: this.local.lawsuitRequest.currentUserAsCaseParty.addNewCasePartyDescription2,
          description3: this.local.lawsuitRequest.currentUserAsCaseParty.addNewCasePartyDescription3,
          textInfo: [],
          footerText: '',
          imgLink: './img/addNewCaseParty.png',
          icon: 'mdi-account-group',
          isHovering: false,
        },
      ],
      caseParty: {
        casePartyRole: casePartyRoleEnum.prosecutor,
        partyType: partyTypeEnum.person,
        partyRefId: 1,
        nationalAddress: {},
        contact: {},
        residenceAddress: {},
        subPartyRoleId: null,
      },
      agent: {},
      clients: [],
      attorneyDetails: null,
      loading: false,
      submitLoading: false,
      externalAttorneySourceId: null,
      boxWidth: 1200,
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    ...mapLUTGetters(['countriesForNonSaudi']),
    addNewCaseParty() { return this.selectedAction === 0; },
    addCurrentUserAsProsecuter() { return this.selectedAction === 1; },
    addCurrentUserAsAgent() { return this.selectedAction === 2; },
    addCurrentUserAsLawyer() { return this.selectedAction === 3; },
    addCurrentUserAsAgentOrLawyer() { return this.addCurrentUserAsAgent || this.addCurrentUserAsLawyer; },
  },
  watch: {
    addCurrentUserAsCaseParty(newValue) {
      if (newValue) {
        this.$refs['actions-modal'].show();
      } else {
        this.$refs['actions-modal'].close();
      }
    },
  },
  mounted() {
    this.getCountries();
    if (this.userInfo.userType == this.userType.najizCitizen) {
      this.actions = this.actions.filter(x => x.id != 3);
      this.boxWidth = 900;
    }
    else if (this.userInfo.userType == this.userType.najizLawyer) {
      this.actions = this.actions.filter(x => x.id != 1 && x.id != 2);
      this.boxWidth = 600;
    }
  },
  methods: {
    ...mapLUTActions(['getCountries']),
    ...mapSysActions(['checkPersonalAddress', 'getAttorneyDetails']),
    selectedActionSubmitted() {
      this.$refs['actions-form'].$validator.validateAll()
        .then((valid) => {
          if (valid) {
            if (this.addNewCaseParty) {
              this.$emit('canceled');
            } else if (this.addCurrentUserAsProsecuter) {
              this.$refs['complete-current-user-info-modal'].show();
              this.prepareCurrentUserProsecuterData();
            } else {
              this.loading = true;
              this.getAttorneyDetails(this.attorneyCode)
                .then((details) => {
                  this.$set(this, 'attorneyDetails', details);
                  const attorneyCountry = (this.countriesForNonSaudi || []).find(a => a.name == details.kharjiaCountry);
                  if (attorneyCountry)
                    this.externalAttorneySourceId = attorneyCountry.id;

                  this.$refs['actions-modal'].close();
                  this.$refs['complete-current-user-info-modal'].show();
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          }
        });
    },
    setSelectedAction(actionId) {
      this.selectedAction = actionId;
    },
    prepareCurrentUserProsecuterData() {
      this.$set(this.caseParty, 'socialIdType', this.userInfo.socialIdType);
      this.$set(this.caseParty, 'socialId', this.userInfo.socialId);
      this.$set(this.caseParty, 'firstName', this.userInfo.firstName);
      this.$set(this.caseParty, 'fatherName', this.userInfo.fatherName);
      this.$set(this.caseParty, 'grandFatherName', this.userInfo.grandFatherName);
      this.$set(this.caseParty, 'familyName', this.userInfo.familyName);
      this.$set(this.caseParty, 'dateOfBirth', this.userInfo.dateOfBirth);
      this.$set(this.caseParty, 'nationalityCountryId', this.userInfo.socialIdType === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
      this.$set(this.caseParty, 'sex', this.userInfo.gender);
      this.$set(this.caseParty, 'isRetrievedFromMoi', true);
      if (this.caseParty.socialId && (this.userInfo.socialIdType == socialIdentityTypeEnum.nationalId || this.userInfo.socialIdType == socialIdentityTypeEnum.regularResidency)) {
        this.checkPersonalAddress(this.caseParty.socialId)
          .then((address) => {
            this.$set(this.caseParty, 'nationalAddress', {
              ...this.caseParty.nationalAddress,
              ...address.nationalAddress,
            });
            this.$set(this.caseParty, 'nationalAddresses', address.nationalAddresses);
          });
      }
      else {
        this.$set(this.caseParty, 'residenceAddress', { countryId: countriesEnum.saudiArabia });
      }
    },
    submit() {
      if (this.addCurrentUserAsAgentOrLawyer) {
        const tabs = Object.values(this.$refs['complete-agent-info-form-component'].$refs);
        const tabsKeys = Object.keys(this.$refs['complete-agent-info-form-component'].$refs);

        const forms = [
          this.$refs['complete-agent-info-form-component'].$validator.validateAll(),
        ];

        tabs.forEach((group) => {
          group.forEach((component) => {
            forms.push(component.$validator.validateAll());
          });
        });

        Promise.all(forms).then((results) => {
          tabsKeys.forEach((tabKey, index) => {
            this.formsValidations = {
              ...this.formsValidations,
              [tabKey]: results[index + 1],
            };
          });

          if (results.every(valid => valid)) {
            this.$emit('save', this.prepareAndGetCaseParties());
            this.$refs['complete-current-user-info-modal'].close();
          }
        });
      } else if (this.addCurrentUserAsProsecuter) {
        this.$refs['complete-current-user-info-form'].$validator.validateAll()
          .then((valid) => {
            if (valid) {
              this.$emit('save', this.prepareAndGetCaseParties());
              this.$refs['complete-current-user-info-modal'].close();
              this.$refs['actions-modal'].close();
            }
          });
      }
    },
    prepareAndGetCaseParties() {
      if (this.addCurrentUserAsProsecuter && this.caseParty) {
        return [{
          ...initialData().selectedCaseParty,
          ...JSON.parse(JSON.stringify(this.caseParty)),
          objectKey: uuidGenerator(),
          partyType: partyTypeEnum.person,
          casePartyRole: casePartyRoleEnum.prosecutor,
        }];
      }
      else if (this.addCurrentUserAsAgentOrLawyer && this.agent) {
        let casePartyRole = casePartyRoleEnum.agent;
        if (this.addCurrentUserAsLawyer) casePartyRole = casePartyRoleEnum.lawyer;
        const agent = {
          ...initialData().selectedCaseParty,
          ...JSON.parse(JSON.stringify(this.agent)),
          objectKey: uuidGenerator(),
          partyRefId: 1,
          partyType: partyTypeEnum.person,
        };
        const clients = [];
        this.clients.forEach((c) => {
          const client = {
            ...initialData().selectedCaseParty,
            ...c,
            objectKey: uuidGenerator(),
            partyRefId: 1,
            partyType: partyTypeEnum.person,
            casePartyRole: casePartyRoleEnum.prosecutor,
          };
          clients.push(client);
          agent.relatedPartiesInfo.push({
            objectKey: uuidGenerator(),
            socialIdType: client.socialIdType,
            socialId: client.socialId,
            firstName: client.firstName,
            fatherName: client.fatherName,
            grandFatherName: client.grandFatherName,
            familyName: client.familyName,
            commercialRegisterationNumber: client.commercialRegisterationNumber,
            name: client.firmName,
            casePartyObjectKey: client.objectKey,
            casePartyRole: casePartyRole,
            relatedCasePartyRole: client.casePartyRole,
            relatedPartyType: client.partyType,
            attorneyNumber: this.attorneyDetails.attorneyNumber,
            attorneyTypeId: this.attorneyDetails.attorneyTypeId,
            isApprovedFromMofa: this.attorneyDetails.isApprovedFromMofa,
            isApprovedFromMoj: this.attorneyDetails.isApprovedFromMoj,
            externalAttorneySourceId: this.externalAttorneySourceId,
            isVerified: this.attorneyDetails.isVerified,
            isRelative: this.isRelative,
            relativeDescription: this.relativeDescription,
          });
        });
        return [...clients, agent];
      }
    },
    closeModal() {
      this.resetForm();

      this.selectedAction = null;
      this.attorneyCode = null;
      this.isRelative = null;
      this.relativeDescription = null;
      this.attorneyDetails = null;

      this.$refs['actions-form'].$validator.reset();
    },
    onActionsModalClose() {
      this.$emit('update:add-current-user-as-case-party', false);
    },
    resetForm() {
      this.caseParty = {
        casePartyRole: casePartyRoleEnum.prosecutor,
        partyType: partyTypeEnum.person,
        partyRefId: 1,
        nationalAddress: {},
        contact: {},
        subPartyRoleId: null,
      };
      this.agent = {};
      this.clients = [];
    },
    onAgentPopupError() {
      this.$refs['complete-current-user-info-modal'].close();
      this.attorneyCode = null;
      this.$emit('update:add-current-user-as-case-party', true);
    },
  },
};
</script>

<style lang="scss" scoped>
$card-headline-color: #484952;
$highlighted-color: #dc0505;
$normal-text-color: #74778f;

.actions-form {
  div.d-flex {
    cursor: pointer;
    &:hover {
      .description {
        color: $highlighted-color;
      }
    }
  }

  p.card-headline {
    min-height: 11%;
    color: $card-headline-color !important;
    font-weight: bold;
    font-size: 20px;
  }
  .highlighted {
    color: $highlighted-color;
  }

  .description {
    color: $normal-text-color;
    font-weight: bold;
    font-size: 13px;
  }

  .bordered {
    border: 2px solid #49cac0;
    .description {
      color: $highlighted-color;
    }
  }

  img.card-img {
    width: auto;
    height: 140px;
    display: block;
    margin: auto;
    font-size: 48px;
  }
  .icon-offline {
    width: auto;
    display: block;
    margin: auto;
    font-size: 150px;
    text-align: center;
  }
  .icon-online {
    width: auto;
    display: block;
    margin: auto;
    font-size: 150px;
    color: #75d6ce;
    text-align: center;
  }
}

p.modal-header-text {
  color: $card-headline-color !important;
  font-size: 20px;
}

// Small devices (landscape phones, 576px and up)
@media (max-width: 576px) {
  .v-card__title {
    padding: 8px;
  }
  .actions-form p.card-headline {
    min-height: 6%;
  }
  .actions-form img.card-img {
    height: 90px;
  }
  .actions-form .description {
    font-size: 16px;
    padding: 0;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .actions-form .description {
    font-size: 16px;
    padding: 0;
  }
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .actions-form .description {
    font-size: 16px;
    padding: 0;
  }
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>